module.exports = __webpack_public_path__ + "img/wait.deb06ad7.png";